export const PRODUCTS = [
  { value: "ALL", label: "All Products" },
  { value: "AC", label: "Accident (AC)" },
  { value: "CI", label: "Critical Illness (CI)" },
  { value: "HI", label: "Hospital Indemnity (HI)" },
];

export const quarterIndex = (quarter) => {
  const [year, number] = quarter.split("-Q");
  return Number(year) * 4 + Number(number) - 1;
};

export const quarterFromIndex = (index) =>
  `${Math.floor(index / 4)}-Q${(index % 4) + 1}`;

export const currentQuarter = () => {
  const now = new Date();
  return `${now.getFullYear()}-Q${Math.floor(now.getMonth() / 3) + 1}`;
};

export const trailingQuarters = (count) => {
  const end = quarterIndex(currentQuarter());
  return { from: quarterFromIndex(end - count + 1), to: quarterFromIndex(end) };
};

export const planYear = (offset = 0) => {
  const year = new Date().getFullYear() - offset;
  return { from: `${year}-Q1`, to: `${year}-Q4` };
};

export const RANGE_PRESETS = [
  { key: "last4", label: "Last 4 Quarters", resolve: () => trailingQuarters(4) },
  { key: "last8", label: "Last 8 Quarters", resolve: () => trailingQuarters(8) },
  { key: "plan", label: "Current Plan Year", resolve: () => planYear(0) },
  { key: "prior", label: "Prior Plan Year", resolve: () => planYear(1) },
];

export const quarterOptions = (back = 20, forward = 2) => {
  const end = quarterIndex(currentQuarter()) + forward;
  const options = [];
  for (let index = end; index >= end - back - forward; index -= 1) {
    options.push(quarterFromIndex(index));
  }
  return options;
};

export const monthLabel = (month) => {
  if (!month) return "—";
  const [year, index] = month.split("-");
  const names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  return `${names[Number(index) - 1]} ${year}`;
};

export const downloadCsv = (filename, rows, columns) => {
  const header = columns.map((column) => column.label).join(",");
  const body = rows.map((row) =>
    columns.map((column) => {
      const value = row[column.key];
      return typeof value === "number" ? value.toFixed(2) : `"${String(value ?? "").replace(/"/g, '""')}"`;
    }).join(",")
  );
  const blob = new Blob([[header, ...body].join("\n")], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
